'use strict';

import {responseToOriginalFormat} from './reviewResponses/reviewResponses'
import {map, reject, uniqBy, mapKeys} from 'lodash'
import {responseCreated, ADVANCED_SEARCH_OPTIONS} from '../ReviewsTabData'
import { ToastService } from '../../../components/toasts/Toasts';
import brandConfigStore from "../../../services/config/BrandConfigStore";


const REVIEW_RESPONSE_MODE_SINGLE = 'Single Review'
const REVIEW_RESPONSE_MODE_MULTIPLE = 'Multiple Reviews'

angular.module('clientDashboardApp').directive('reviewList', function (
  $timeout,
  $cookies,
  reviewGenService,
  reviewService,
  reviewResponseTemplateService,
  userService,
  $uibModal,
  configService,
  confirmService,
  reactContainer) {

  return {
    restrict: 'E',
    template: require('./reviewList.html'),
    link: function(scope, element, attrs) {
      // Don't display date selector by default
      scope.displayDateSelector = attrs.displayDateSelector === 'true' ? 'true' : 'false'
    },
    controller: ($scope,$anchorScroll,$window) => {

      $scope.reviewResponse = {
        isPublic: false
      }

      $scope.setTagEditingAngularCallback = () => $scope.openTagConfigModal();
      reactContainer.getContainer() && reactContainer.getContainer().setTagEditingAngularCallback($scope.setTagEditingAngularCallback);

      $scope.demoFlag = !$scope.brandConfig.restrictions.hideDemoReviewResponses;
      $scope.hideReviewBulkResponding = $scope.brandConfig.restrictions.hideReviewBulkResponding;
      $scope.REVIEW_RESPONSE_MODE_SINGLE = REVIEW_RESPONSE_MODE_SINGLE
      $scope.REVIEW_RESPONSE_MODE_MULTIPLE = REVIEW_RESPONSE_MODE_MULTIPLE
      $scope.reviewResponseMode = REVIEW_RESPONSE_MODE_SINGLE
      $scope.reviewResponseBulkText = ""
      $scope.allReviewsMultiselected = {isSelected: false}
      $scope.multiSelectedReviewCount = 0
      $scope.responseTemplates = []

      // TODO - Consolidate bulk review fields into a single bulk review object.

      $scope.selectedResponseTemplate = {...$scope.defaultTemplate}
      $scope.$watch('loadingReviewDetails', () => {
        refreshMultiSelectedRowCount()
      })
      $scope.selectMultiResponseTemplate = (template) => {
        $scope.selectedResponseTemplate = template
        $scope.reviewResponseBulkText = template.body
      }

      $scope.selectMultiRRResponseTemplate = (template) => {
        $scope.roundRobinTemplates.templates.push({body:template.body,id:template.id});
        //we want to remove the first empty box if a template was selected
        if ($scope.roundRobinTemplates.templates[0].body === "")
          $scope.roundRobinTemplates.templates.splice(0,1)
      }

      const defaultLimit = $scope.reviewSearchOptions && $scope.reviewSearchOptions.limit
      $scope.reviewResponseModeChanged = (mode) => {
        const shouldContinue = (mode === REVIEW_RESPONSE_MODE_SINGLE) ? Promise.resolve(true) : confirmService.confirm(
          "Bulk Review Responses",
          "Only reviews from supported Providers with verified user credentials can be responded to. Please visit the External Accounts page to verify your user credentials if necessary.",
          confirmService.WARNING,
          "multipleReviewResponse",
          "Don't warn me again."
        );
        shouldContinue.then(proceed => {
          if (proceed === true) {
            $scope.reviewResponseMode = mode
            $scope.reviewSearchOptions.limit = mode === REVIEW_RESPONSE_MODE_SINGLE ? defaultLimit : 100;
            if (mode === REVIEW_RESPONSE_MODE_MULTIPLE && $scope.reviews.length < 100 && $scope.hasMore !== false) {
              $scope.loadMoreResults()
            }
          }
        })
      }

      const refreshMultiSelectedRowCount = () => {
        const countCanResponse = $scope.reviews.filter(review => review.canRespond === true).length
        $scope.allReviewsMultiselected.isSelected = countCanResponse > 0 && ($scope.reviews.filter(review => review.canRespond === true && review.canRespondBulk == true).length === $scope.reviews.filter(review => review.multiSelected === true).length)
        $scope.multiSelectedReviewCount = $scope.reviews.map(x => x.multiSelected === true ? 1 : 0).reduce((a, b) => a + b, 0)
      }

      $scope.multiSelectAllReviews = () => {
        $scope.reviews.forEach(review => {
          review.multiSelected = review.canRespond && review.canRespondBulk && $scope.allReviewsMultiselected.isSelected
        })
        refreshMultiSelectedRowCount()
      }

      $scope.toggleMultiSelectReview = () => {
        refreshMultiSelectedRowCount()
      }

      $scope.removeRRresponse = (index) => {
        $scope.roundRobinTemplates.templates.splice(index, 1);
      }

      $scope.clearRRresponses = () => {
        $scope.roundRobinTemplates.templates = [Object.assign({}, $scope.defaultTemplate)]
      }

      $scope.roundRobinTemplates = {
        templates: [Object.assign({},$scope.defaultTemplate)] //start with a blank one.
      };

      $scope.multiResponseToReviews = () => {
        let templateIndex = 0
        function mapToReviewResponseInstruction(review) {
          const detail = $scope.roundRobinTemplates.templates[templateIndex].body
          templateIndex = (templateIndex + 1) % $scope.roundRobinTemplates.templates.length
          return {
            reviewId: review.reviewId,
            detail: detail
          }
        }

        const selectedReviews = $scope.reviews.filter(review => review.multiSelected === true)
        // Stub apartment guide review responses for demos
        const fakeReviewResponses = selectedReviews.filter(review => review.contentProvider === "APARTMENTGUIDE" && $scope.demoFlag === true)

        fakeReviewResponses.forEach(rev => {
          rev.responses.push({
            _id: { $oid: (new Date().getTime()) }, // Fake id so angular can iterate using track by
            publishingStatus: "PUBLISHED",
            username: userService.getCurrentUser().firstName,
            detail: $scope.reviewResponseBulkText
          })
        })

        const realReviewResponses = selectedReviews
          .filter(review => !(review.contentProvider === "APARTMENTGUIDE" && $scope.demoFlag === true))
          .map(mapToReviewResponseInstruction)

        $scope.savingMultipleReviewResponses = true
        reviewService.submitReviewResponses(realReviewResponses)
          .then(results => {
            results["succeeded"].forEach(apiResponse => {
              $scope.$emit(responseCreated, apiResponse)
              const rev = $scope.reviews.find(review => review.reviewId === apiResponse.updatedReview.id)
              const response = apiResponse.reviewResponse
              if (response.publishingStatus === "PUBLISHED") {
                rev.responses = apiResponse.updatedReview.responses.map(responseToOriginalFormat)
              } else {
                if ($scope.demoFlag) {
                  // for response demo accounts, don't show publish errors
                  response.publishingStatus = "PUBLISHED"
                }
                rev.responses.push(responseToOriginalFormat(response))
              }
            })

            const totalSuccesses = results["succeeded"].map(result => result.reviewResponse.publishingStatus === "PUBLISHED" ? 1 : 0).reduce((a, b) => a + b, 0)
            const totalFailures = results["succeeded"].map(result => result.reviewResponse.publishingStatus === "PUBLISHED" ? 0 : 1).reduce((a, b) => a + b, 0)

            if (totalFailures === 0) {
              ToastService.success("Success", `Responded to ${totalSuccesses} reviews.`)
            } else if (totalSuccesses > 0) {
              ToastService.warning("Some Failures", `Responded to ${totalSuccesses} reviews. Failed to respond to ${totalFailures} reviews.`)
            } else {
              ToastService.error("Failed", `Failed to respond to ${totalFailures} reviews.`)
            }

            $scope.savingMultipleReviewResponses = false
            $scope.reviewResponseBulkText = ""
          }, error => {
            $scope.savingMultipleReviewResponses = true
          })
      }

      $scope._ = _

      $anchorScroll.yOffset = 30;

      $scope.isSmall = false;
      let window = angular.element($window)
      window.bind('resizeEnd',() => {
        setIsSmall();
      })

      setIsSmall();

      $scope.hideYelpStuff = false

      userService.currentUser().then(function (resp) {
        if (resp.userId == "57eea55f66d4e052c8f6b0f0") {
          $scope.hideYelpStuff = true
        }
      });

      function setIsSmall() {
        $scope.isSmall =  window.width() < 768
      }

      $scope.getEmbeddedReviews = review => {
        return review.syndicatedReviews && review.syndicatedReviews.length > 0 ?
          review.syndicatedReviews :
          review.originalReview ?
            [review.originalReview] :
            [];
      }

      $scope.showResponseFormForReview = function(reviewId) {
        $scope.clearResponse()
        $scope.reviewIdForResponseForm = reviewId

        let idString = 'review-response-form-'+reviewId
         $timeout(()=> {
          $anchorScroll(idString)
           $('#'+'review-response-form-'+reviewId).find('textarea').focus()
        },100)
      }

      $scope.scrollBackToReview = (reviewId) => {
          let idString = 'review-'+reviewId
          $anchorScroll(idString)
      }

      $scope.clearResponse = function() {
        $scope.reviewIdForResponseForm = null
        $scope.reviewResponse = { isPublic: false }

      }

      $scope.selectFilterOption = (key, option) => {
        if ($scope.filterState[key] !== option) {
          $scope.filterState[key] = option
          $scope.sortReviewsTable()
        }
      }

      $scope.toggleTag = tag => {
        $scope.searchConfig.tags = !_.contains($scope.searchConfig.tags,tag.id) ? _.union($scope.searchConfig.tags,[tag.id]) : _.difference($scope.searchConfig.tags,[tag.id])
      }

      $scope.toggleAdvancedSearchOption = (option) => {
        let oppositeOption = option.parameterName ?
          ADVANCED_SEARCH_OPTIONS.filter(item => (item.parameterName === option.parameterName && item.value !== option.value)) :
          []
        let optionsToRemove = option.parameterName ?
          _.union(ADVANCED_SEARCH_OPTIONS.filter(item => (!item.parameterName)),oppositeOption) :
          ADVANCED_SEARCH_OPTIONS.filter(item => (item.parameterName))

        $scope.filterState.advancedSearch = !_.contains($scope.filterState.advancedSearch,option) ?
          _.chain($scope.filterState.advancedSearch)
            .union([option])
            .difference(optionsToRemove)
            .value() :
          _.difference($scope.filterState.advancedSearch,[option])
      }

      $scope.openTagConfigModal = () => {
        var modalInstance = $uibModal.open({
          template: require('../reviewTagsModal.html'),
          size: 'md',
          windowClass: 'review-tags-modal',
          resolve:  {
            parentScope: $scope,
            config : $scope.brandConfig
          },
          controller: "ReviewTagsModalCtrl"
        })

        modalInstance.result.then(resp => onTagConfigClose(resp));
      }

      function onTagConfigClose(resp) {
        if(resp.state===$scope.states.success) {
          updateTagNames(resp.config.reviewTags)
          const tagsToDelete = $scope.brandConfig.reviewTags.filter(existingTag => {
            const newTag = resp.config.reviewTags.find(newTag => newTag["_id"]["$oid"] === existingTag["_id"]["$oid"])

            return newTag === undefined
          }).map(x => x["_id"]["$oid"])
          if (tagsToDelete.length) {
            removeTagsFromReviews(tagsToDelete)
            $scope.searchConfig.tags = reject($scope.searchConfig.tags, (item) => (tagsToDelete.indexOf(item) >= 0))
          }
          $scope.tagsFromReviews = reject($scope.tagsFromReviews, (item) => tagsToDelete.indexOf(item.id) >= 0)
          $scope.brandConfig.reviewTags = resp.config.reviewTags
          $scope.reviewTags = uniqBy(resp.config.reviewTags.map((item) => ({
            name: item.name,
            id: item._id.$oid
          })).concat($scope.tagsFromReviews), "id")
          $scope.updateTagsForAccount();

          // Required to update mobx state, so this updated brand config can be used elsewhere in React-land.
          brandConfigStore.resetBrandConfig();
        }
      }

      const removeTagsFromReviews = (tagIds) => {
        $scope.reviews = map($scope.reviews,(reviewItem) => ({...reviewItem,reviewTags:reject(reviewItem.reviewTags,(tagItem) => (tagIds.indexOf(tagItem._id.$oid) >= 0))}))
      }

      // Updates any tags whose names may have changed
      const updateTagNames = (tags) => {
        $scope.reviews = $scope.reviews.map(reviewItem => ({
          ...reviewItem,
          reviewTags: reviewItem.reviewTags.map(reviewTag => {
            const maybeNewTag = tags.find(tag => tag["_id"]["$oid"] === reviewTag["_id"]["$oid"])
            return {
              ...reviewTag,
              name: maybeNewTag !== undefined ? maybeNewTag["name"] : reviewTag.name
            }
          })
        }))
      }

    }

  };
});
